import styled from 'styled-components';

const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
`;

export default ButtonGroup;